import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=084502f8&scoped=true"
import script from "./Timeline.vue?vue&type=script&lang=ts"
export * from "./Timeline.vue?vue&type=script&lang=ts"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=084502f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084502f8",
  null
  
)

export default component.exports